module.exports = __webpack_public_path__ + "3a81f8d7306f9b911fb92a73cb1eeba9.svg";